import { Fade } from "react-awesome-reveal";
import { motion } from 'framer-motion';
import { useScrollVariables } from '../scrollVariables';

export default function Freelance() {

        const {
                labelContainerRef,
                projectTextRef,
                labelOpacity,
                projectTextOpacity,
        } = useScrollVariables();

        return (
                <div className="freelance" id="freelance">
                        <div className="label-container" ref={labelContainerRef}>
                                <motion.div style={{ opacity: labelOpacity }}>
                                        04 FREELANCE
                                </motion.div>
                        </div>
                        <div className="container info-section justify-content-center">
                                <div className="grid-even-columns">
                                        <div className="description-title">
                                                <h3>CLIENT</h3>
                                        </div>
                                        <div className="description-text">
                                                <h3>VARIOUS</h3>
                                        </div>
                                </div>
                                <div className="grid-even-columns">
                                        <div className="description-title">
                                                <h3>ROLE</h3>
                                        </div>
                                        <div className="description-text">
                                                <h3>FREELANCE GRAPHIC DESIGN</h3>
                                        </div>
                                </div>
                                <div className="grid-even-columns">
                                        <div className="description-title">
                                                <h3>DELIVERABLES</h3>
                                        </div>
                                        <div className="description-text">
                                                <h3>LOGO DESIGN</h3>
                                                <h3>BRAND IDENTITY</h3>
                                                <h3>VISUAL IDENTITY</h3>
                                                <h3>PHOTOGRAPHY</h3>
                                                <h3>MOTION DESIGN</h3>
                                                <h3>THUMBNAIL DESIGN</h3>
                                        </div>
                                </div>
                                <div className="grid-even-columns">
                                        <div className="description-title">
                                                <h3>YEAR</h3>
                                        </div>
                                        <div className="description-text">
                                                <h3>PRESENT</h3>
                                        </div>
                                </div>
                        </div>
                        <div className="d-flex justify-content-center">
                                <motion.p className="project-text" ref={projectTextRef} style={{ opacity: projectTextOpacity }}>My freelance projects are a way for me to be as creative as possible, all while satisfying client expectations. It is always a pleasure to develop a deep connection with clients and guide them through the design process. </motion.p>
                        </div>
                        <div className="container work-container">
                                <div className="row align-items-center justify-content-center" id="gallery">
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-logo.png" className="slipstream-work-img-logo" alt="slipstream-logo" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-mockup-vinyl.png" className="slipstream-work-mockup" alt="slipstream-mockup" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-4 col-xs-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-poster-1.jpg" className="slipstream-work-img-group" alt="slipstream-img-1" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-4 col-xs-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-logo-poster.jpg" className="slipstream-work-img-group" alt="slipstream-img-2" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-4 col-xs-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-poster-2.jpg" className="slipstream-work-img-group" alt="slipstream-img-3" />
                                                </Fade>
                                        </div>
                                        <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-bw-img-1.jpg" className="slipstream-work-img-photos" alt="slipstream-img-4" />
                                                </Fade>
                                        </div>
                                        <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-bw-img-2.jpg" className="slipstream-work-img-photos" alt="slipstream-img-5" />
                                                </Fade>
                                        </div>
                                        <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-col-img-1.jpg" className="slipstream-work-img-photos" alt="slipstream-img-6" />
                                                </Fade>
                                        </div>
                                        <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/slipstream-work/slipstream-col-img-2.jpg" className="slipstream-work-img-photos" alt="slipstream-img-7" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-logo.png" className="fusco-work-img-logo" alt="fusco-logo" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-mockup.png" className="fusco-work-img-mockup" alt="fusco-mockup" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-4 col-xs-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-poster-1.jpg" className="fusco-work-img-group" alt="fusco-img-1" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-4 col-xs-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-logo-poster.jpg" className="fusco-work-img-group" alt="fusco-img-2" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-lg-4 col-xs-4 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-poster-2.jpg" className="fusco-work-img-group" alt="fusco-img-3" />
                                                </Fade>
                                        </div>
                                         <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-bw-img-1.jpg" className="fusco-work-img-photos" alt="fusco-img-4" />
                                                </Fade>
                                        </div>
                                         <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-bw-img-2.jpg" className="fusco-work-img-photos" alt="fusco-img-5" />
                                                </Fade>
                                        </div>
                                        <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-col-img-1.jpg" className="fusco-work-img-photos" alt="fusco-img-6" />
                                                </Fade>
                                        </div>
                                        <div className="col-6 col-lg-3 col-xs-2 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/fusco-work/fusco-col-img-2.jpg" className="fusco-work-img-photos" alt="fusco-img-7" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/philpott-work/philpott-logo.png" className="philpott-work" alt="philpott-logo" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 text-center">
                                                <Fade duration={500}>
                                                        <video playsInline autoPlay muted loop preload="metadata" src="img/philpott-work/philpott-logo-animation.mp4" className="philpott-work-animation" alt="philpott-logo-animation" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-3 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/philpott-work/philpott-thumbnail-1.jpg" className="philpott-thumbnail" alt="philpott-thumbnail" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-3 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/philpott-work/philpott-thumbnail-2.jpg" className="philpott-thumbnail" alt="philpott-thumbnail" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-3 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/philpott-work/philpott-thumbnail-3.jpg" className="philpott-thumbnail" alt="philpott-thumbnail" />
                                                </Fade>
                                        </div>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-3 text-center">
                                                <Fade duration={500}>
                                                        <img src="img/philpott-work/philpott-thumbnail-4.jpg" className="philpott-thumbnail" alt="philpott-thumbnail" />
                                                </Fade>
                                        </div>
                                </div>
                        </div>
                </div>
        )
}